// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.old-convo-container {
  height: 93% !important;
}

.custom-accordion {
  width: 100%;
}

.accordion-item {
  border: 1px solid #ddd;
  margin-bottom: 8px;
}

.accordion-header {
  padding: 10px;
  background-color: #f4f4f4;
  cursor: pointer;
}

.accordion-header:hover {
  background-color: #e0e0e0;
}

.accordion-header.active {
  background-color: #d4d4d4;
}

.accordion-content {
  padding: 10px;
}

.old-chat {
  display: flex;
  flex-direction: column;
}
.old-chat .user-info {
  display: flex;
  flex-direction: row;
}
.old-chat .user-info .user-info-details {
  text-align: left;
  width: 98%;
}
.old-chat .response-container {
  text-align: left;
  display: flex;
  overflow: auto;
  height: 100%;
  margin-top: 1em;
}
.old-chat .evr-response {
  margin-top: 0.25em;
  border-top: 2px double #004987;
}
.old-chat .highlight-link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.old-chat .btn-primary {
  background-color: #004987 !important;
}

.evr-chat {
  height: 45%;
}

.evr-chat-full {
  height: 89%;
}

.h-10 {
  height: 10%;
}`, "",{"version":3,"sources":["webpack://./src/components/OldConvo.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AACI;EACE,gBAAA;EACA,UAAA;AACN;AAGE;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AADJ;AAIE;EACE,kBAAA;EACA,8BAAA;AAFJ;AAKE;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AAHJ;AAME;EACE,oCAAA;AAJJ;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF","sourcesContent":[".old-convo-container{\n  height: 93% !important;\n}\n\n.custom-accordion {\n  width: 100%;\n}\n\n.accordion-item {\n  border: 1px solid #ddd;\n  margin-bottom: 8px;\n}\n\n.accordion-header {\n  padding: 10px;\n  background-color: #f4f4f4;\n  cursor: pointer;\n}\n\n.accordion-header:hover {\n  background-color: #e0e0e0;\n}\n\n.accordion-header.active {\n  background-color: #d4d4d4;\n}\n\n.accordion-content {\n  padding: 10px;\n}\n\n\n.old-chat {\n  display: flex;\n  flex-direction: column;\n\n  .user-info {\n    display: flex;\n    flex-direction: row;\n    .user-info-details{\n      text-align: left;\n      width: 98%;\n    }\n  }\n\n  .response-container {\n    text-align: left;\n    display: flex;\n    overflow: auto;\n    height: 100%;\n    margin-top: 1em;\n  }\n\n  .evr-response {\n    margin-top: .25em;\n    border-top: 2px double #004987;\n  }\n\n  .highlight-link {\n    color: blue;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  .btn-primary {\n    background-color: #004987 !important;\n  }\n}\n\n.evr-chat {\n  height: 45%;\n}\n\n.evr-chat-full {\n  height: 89%;\n}\n\n.h-10 {\n  height: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
